const news = {
  state: {
    attributionEmployeeListTree: [], // 集团
    areaEmployeeListTree: [], // 片区
    kindergartenEmployeeListTree: [], // 园所
    kindergartenParentListTree: [] // 家长
  },
  getters: {

  },
  mutations: {
    SET_attributionEmployeeListTree (state, attributionEmployeeListTree) {
      state.attributionEmployeeListTree = attributionEmployeeListTree
    },
    SET_areaEmployeeListTree (state, areaEmployeeListTree) {
      state.areaEmployeeListTree = areaEmployeeListTree
    },
    SET_kindergartenEmployeeListTree (state, kindergartenEmployeeListTree) {
      state.kindergartenEmployeeListTree = kindergartenEmployeeListTree
    },
    SET_kindergartenParentListTree (state, kindergartenParentListTree) {
      state.kindergartenParentListTree = kindergartenParentListTree
    }
  },
  actions: {}
}

export default news



// WEBPACK FOOTER //
// ./src/store/modules/news.js